(function () {
  'use strict';

  const DEBOUNCE_MS  = 350;
  const CONTAINER_ID = 'BlogGridContainer';
  const HIDE_CLASS   = 'hide';
  const SCROLL_ANCHOR_ID = 'AjaxScrollAnchor';

  const container   = document.getElementById(CONTAINER_ID);
  const searchInput = document.querySelector('[data-blog-search-input]');
  const searchForm  = document.querySelector('[data-blog-search-form]');

  if (!container) return;

  const params = new URLSearchParams(window.location.search);
  let currentQuery  = params.get('q') || '';
  let debounceTimer = null;

  if (searchInput) searchInput.value = currentQuery;

  function applyFilter() {
    const items = container.querySelectorAll('[data-title]');
    let visibleCount = 0;
    const queryLower = currentQuery ? currentQuery.toLowerCase() : '';

    items.forEach(function (item) {
      const title   = (item.getAttribute('data-title') || '').toLowerCase();
      const excerpt = (item.getAttribute('data-excerpt') || '').toLowerCase();
      const match   = !queryLower || title.indexOf(queryLower) !== -1 || excerpt.indexOf(queryLower) !== -1;

      item.classList.toggle(HIDE_CLASS, !match);
      if (match) visibleCount++;
    });

    const emptyEl = container.querySelector('.main-blog_empty-js');
    if (emptyEl) {
      emptyEl.classList.toggle(HIDE_CLASS, visibleCount > 0);
    } else if (visibleCount === 0 && items.length > 0) {
      const wrapper = document.createElement('div');
      wrapper.className = 'container py-3xl text-center text-grey main-blog_empty-js';
      wrapper.innerHTML = '<p class="body-copy">No blog posts found.</p>';
      container.appendChild(wrapper);
    }
  }

  function buildUrl(q) {
    const base = window.location.pathname;
    return q ? base + '?q=' + encodeURIComponent(q) : base;
  }

  function updateUrl(pushState) {
    const url = buildUrl(currentQuery);
    if (pushState) history.pushState({ q: currentQuery }, '', url);
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        currentQuery = searchInput.value.trim();
        applyFilter();
        updateUrl(true);
      }, DEBOUNCE_MS);
    });
  }

  if (searchForm) {
    searchForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (searchInput) currentQuery = searchInput.value.trim();
      applyFilter();
      updateUrl(true);
    });
  }

  container.addEventListener('click', function (e) {
    const link = e.target.closest('.pagination a[href], .pagination__item[href]');
    if (!link || !link.href) return;
    e.preventDefault();

    const fetchUrl = new URL(link.href).pathname + new URL(link.href).search;
    container.classList.add('is-loading');

    fetch(fetchUrl, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Network error ' + r.status);
        return r.text();
      })
      .then(function (html) {
        const parser  = new DOMParser();
        const doc     = parser.parseFromString(html, 'text/html');
        const newGrid = doc.getElementById(CONTAINER_ID);
        if (newGrid) {
          container.innerHTML = newGrid.innerHTML;
          if (searchInput) searchInput.value = currentQuery;
          applyFilter();
          const headerOffset = 80;
          const anchor = container.querySelector('#' + SCROLL_ANCHOR_ID) || document.getElementById(SCROLL_ANCHOR_ID) || container;
          window.requestAnimationFrame(function () {
            const top = anchor.getBoundingClientRect().top + window.scrollY - headerOffset;
            window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
          });
        }
        history.pushState({}, '', fetchUrl);
      })
      .catch(function (err) {
        console.error('[main-blog] pagination fetch failed:', err);
        window.location.href = fetchUrl;
      })
      .finally(function () {
        container.classList.remove('is-loading');
      });
  });

  window.addEventListener('popstate', function () {
    const p = new URLSearchParams(window.location.search);
    currentQuery = p.get('q') || '';
    if (searchInput) searchInput.value = currentQuery;
    applyFilter();
  });

  applyFilter();
})();
